// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_0d624b9a27--switch--Iu4Bo","indicator":"_0d624b9a27--indicator--JD6wH","disabled":"_0d624b9a27--disabled--WS_Zh"};